'use client'

import { ErrorComponent } from 'next/dist/client/components/error-boundary'

import Error from '@components/shared/error/error'

const ErrorPage: ErrorComponent = ({ error }: { error: Error }) => {
  return <Error error={error} />
}

export default ErrorPage
